import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";

const RemovableProduction = (props: RemovableProps<server.dto.ProductionSmallV2>) => {
  return <RemovableLabel {...props}>
    <div>
      {props.value.name}
    </div>
  </RemovableLabel>;
};

export default RemovableProduction;